import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const { pathname, state } = useLocation();
    // Set by in-page tab switches that change the URL (Services.js tabs), so
    // the page stays where the visitor is instead of jumping to the top.
    const keepScroll = Boolean(state && state.keepScroll);

    useEffect(() => {
        // Scroll to top on route change
        if (!keepScroll) window.scrollTo(0, 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps -- run only when the path changes
    }, [pathname]);

    return null;
};

export default ScrollToTop;
